module.exports = __webpack_public_path__ + "media/reskin-images/logo--black-small-9737857e.svg";